// extracted by mini-css-extract-plugin
module.exports = {"box":"Example_style_box__2yZPo","left":"Example_style_left__33uDl","right":"Example_style_right__IlCj0","title":"Example_style_title__1pEUk","inner":"Example_style_inner__3KSH6"};